module.exports = __webpack_public_path__ + "img/stay_informed.f97d2abd.png";